import {
    Alert,
    type AlertColor,
    type AlertProps,
    type Theme,
    alpha,
    shadowElevationsFactory,
    styled,
} from '@lingoda/ui';

export type ToastAlertProps = Omit<AlertProps, 'elevation' | 'variant'>;

export const ToastAlert = (props: ToastAlertProps) => {
    return <AlertStyled {...props} variant="outlined" />;
};

const AlertStyled = styled(Alert)(({ theme, severity = 'success' }) => ({
    width: 392,
    boxShadow: shadowElevationsFactory.level2(...getShadowColors(theme, severity)),
    margin: '0 auto',
}));

const shadowBorderToken: Record<AlertColor, keyof Theme['colors']['border']> = {
    success: 'success-bold',
    info: 'stronger',
    warning: 'warning-bold',
    error: 'danger-bold',
    promotion: 'accent-bold',
};

const getShadowColors = (theme: Theme, severity: AlertColor): [string, string] => {
    const base = theme.colors.border[shadowBorderToken[severity]];

    return [alpha(base, 0.08), alpha(base, 0.12)];
};
